// Native <dialog>-based modal helpers.
//
// HTML contract:
//   <dialog class="bf-modal" id="my-modal">…</dialog>
//   <button data-bf-toggle="modal" data-bf-target="#my-modal">Open</button>
//
// Inside the modal, [data-bf-dismiss="modal"] closes it.

import { $$, on } from './util';

export function open(target: HTMLDialogElement | string): void {
  const dialog = (typeof target === 'string'
    ? document.querySelector(target)
    : target) as HTMLDialogElement | null;
  if (!dialog) return;
  if (typeof dialog.showModal === 'function') dialog.showModal();
  else dialog.setAttribute('open', '');
}

export function close(target: HTMLDialogElement | string): void {
  const dialog = (typeof target === 'string'
    ? document.querySelector(target)
    : target) as HTMLDialogElement | null;
  if (!dialog) return;
  if (typeof dialog.close === 'function') dialog.close();
  else dialog.removeAttribute('open');
}

export function init(root: ParentNode = document): void {
  for (const trigger of $$<HTMLElement>('[data-bf-toggle="modal"]', root)) {
    const targetSel = trigger.getAttribute('data-bf-target');
    if (!targetSel) continue;
    on(trigger, 'click', (e) => {
      e.preventDefault();
      open(targetSel);
    });
  }
  for (const close_ of $$<HTMLElement>('[data-bf-dismiss="modal"]', root)) {
    on(close_, 'click', () => {
      const dialog = close_.closest('dialog') as HTMLDialogElement | null;
      if (dialog) close(dialog);
    });
  }
  // Close on backdrop click for native dialogs.
  for (const dialog of $$<HTMLDialogElement>('dialog.bf-modal', root)) {
    on(dialog, 'click', (e) => {
      const r = (dialog as HTMLDialogElement).getBoundingClientRect();
      const ev = e as MouseEvent;
      if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) {
        close(dialog);
      }
    });
  }
}
